import { isNil } from 'lodash-es'
import numeral from 'numeral'

export function fileSize(value?: number) {
	const formattedValue =
		isNil(value) || Number.isNaN(value) ? '' : numeral(value).format('0.0 b')

	return formattedValue
}
